module.exports = __webpack_public_path__ + "static/media/tiendachat-new-message-notification-sound.9402750b.mp3";